import {
    SET_APITRAFFICLIST_DASHBOARD_INSIGHT,
    CLEAR_APITRAFFICLIST_DASHBOARD_INSIGHT,
    GET_APITRAFFICLIST_DASHBOARD_INSIGHT_SUCCESS,
    GET_APITRAFFICLIST_DASHBOARD_INSIGHT_FAILED
} from '../../actions/type';

const initialStateAPITrafficListDashboardInsight = { data: null, status: 'idle' };

export default function APITrafficListDashboardInsightReducer(state = initialStateAPITrafficListDashboardInsight, action) {
    const { type, data } = action;

    switch (type) {
        case SET_APITRAFFICLIST_DASHBOARD_INSIGHT:
            return {
                ...state,
                data,
            }
        case CLEAR_APITRAFFICLIST_DASHBOARD_INSIGHT:
            return {
                ...state,
                data: null,
            }
        case GET_APITRAFFICLIST_DASHBOARD_INSIGHT_SUCCESS:
            return {
                ...state,
                status: 'success',
            }
        case GET_APITRAFFICLIST_DASHBOARD_INSIGHT_FAILED:
            return {
                ...state,
                error: data,
                status: 'failed',
            }

        default:
            return state;
    }
}